import React, { useEffect, useState } from "react";
import { css } from "react-emotion";
import { useParams } from "react-router";
import { Button } from "appStyles";
import { appByLanding } from "apis";
import Container from "@material-ui/core/Container";
import { isMobileDevice } from "helpers";
import Footer from "../Footer";
import Header from "../Header";
import ErrorPage from "../ErrorPage";
import { Helmet } from "react-helmet";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;

const wrapper = css`
  font-size: 2em;
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const maxWidthWrapper = css`
  max-width: 1200px;
  display: flex;
  flex-flow: row wrap;
  margin: auto;
`;

const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-top: 50px;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;

  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
  }
`;

const col1_2 = css`
  flex: 0 0 92%;
  margin: auto 4%;

  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 40%;
    text-align: center;
  }
`;

const logoLandingPageStyle = css`
  width: 200px;
  @media only screen and (min-width: 768px) {
    width: 400px;
  }
`;

const textStyle = css`
  font-size: 14px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
  @media only screen and (min-width: 768px) {
    font-size: 20px;
    /* text-align: left; */
  }
`;
const rowToCol = css`
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

const MarginRight = css`
  margin-right: 0px;
  @media only screen and (min-width: 768px) {
    margin-right: 10px;
  }
`;

const NoMatch = ({ history }) => {
  let { app } = useParams();
  // console.log("got app name: " + app);
  const [appObject, setAppObject] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const isMob = isMobileDevice();

  const getAppObject = async () => {
    try {
      // console.log("fetching app object: " + app);
      const result = await appByLanding(app);
      setAppObject(result);
    } catch (e) {
      console.error(e);
      setAppObject(null);
      setErrorMessage("Oops! This page does not exist!");
    }
  };
  const getButtonStyle = () => {
    return css`
      display: inline-block;
      background-color: #89d2d3;
      font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
        Verdana, sans-serif;
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-transform: none;
      width: 200px;
      margin: auto;
      margin-bottom: 30px;
      padding: 10px;
      border-radius: 4px;
      color: white;
      font-weight: bold;
      border: none;
      box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
      font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
        Verdana, sans-serif;
      cursor: pointer;
    `;
  };

  const getTextStyle = (color) => {
    return css`
      /* color: ${color}; */
      color: #000000;
      font-size: 25px;
      margin: 0px;
      text-align: center;
      @media only screen and (min-width: 768px) {
        font-size: 1em;
        padding: 20px 0px;
        /* text-align: left; */
      }
    `;
  };

  const loadWebPage = () => {
    if (appObject) {
      history.push(`/${app}/home`, appObject);
    }
  };

  useEffect(() => {
    // if (window.drift && window.drift.api) {
    //   console.log("found drift");
    //   window.drift.api.widget.hide();
    // }
    getAppObject();
  }, []);

  if (appObject) {
    const { name, primaryColor, logo, deeplinkUrl, websiteEnabled } = appObject;
    // console.dir(appObject);

    const storesImgUrl =
      "https://mobile360-assets.s3.us-east-2.amazonaws.com/store-icons.png";
    return (
      <div className={body}>
        <Helmet>
          <title>{name + " \u2022 Mobile 360"}</title>
          <meta name="twitter:image" content={logo}></meta>
          <meta property="og:image" content={logo}></meta>
          <meta
            property="og:title"
            content={name + " \u2022 Mobile 360"}
          ></meta>
        </Helmet>
        <div className={wrapper}>
          <Header history={history} hideMenu={true} />

          <main
            style={{
              width: "100%",
              minHeight: "calc(100vh - 70px)",
              backgroundColor: "rgb(255, 255, 255)",
              flex: "1 0 auto",
              textAlign: "center",
              paddingRight: "30px",
              paddingLeft: "30px",
            }}
          >
            <h4 className={getTextStyle(primaryColor)}>Welcome to {name}!</h4>

            <div className={row} style={{ marginTop: "20px" }}>
              <div className={maxWidthWrapper}>
                <div className={col + " " + col1_2}>
                  {logo && (
                    <img
                      src={logo}
                      className={logoLandingPageStyle}
                      style={{
                        margin: "auto",
                        marginTop: "40px",
                        borderRadius: ".4em",
                      }}
                    ></img>
                  )}
                </div>
                <div className={col + " " + col1_2}>
                  <p className={textStyle}>
                    <span style={{ textAlign: "center", fontSize: "20px" }}>
                      Want exclusive deals and rewards? Download our{" "}
                      <img
                        style={{
                          display: "inline-block",
                          margin: "0 auto",
                          width: "170px",
                          marginTop: "2px",
                        }}
                        src="https://mobile360-assets.s3.us-east-2.amazonaws.com/m360app.PNG"
                      />
                    </span>
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                    className={rowToCol}
                  >
                    <a
                      href={deeplinkUrl}
                      target="_blank"
                      style={{
                        textDecoration: "none",
                        marginBottom: "10px",
                      }}
                      className={MarginRight}
                    >
                      <Button className={getButtonStyle(primaryColor)}>
                        Download our Mobile360 App
                      </Button>
                    </a>
                    {websiteEnabled ? (
                      <p
                        style={{
                          marginBottom: "35px",
                          fontSize: "20px",
                        }}
                        className={MarginRight}
                      >
                        or
                      </p>
                    ) : null}

                    {websiteEnabled ? (
                      <a
                        style={{ textDecoration: "none", marginBottom: "10px" }}
                      >
                        <Button
                          className={getButtonStyle(primaryColor)}
                          onClick={loadWebPage}
                        >
                          Continue to our Website
                        </Button>
                      </a>
                    ) : null}
                  </div>{" "}
                </div>
                <div style={{ width: "100%", marginTop: "10px" }}>
                  <a href={"https://www.mobile360.io"} target="_blank">
                    <img
                      style={{ width: "160px" }}
                      src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/powered_by_m360.png"
                    ></img>
                  </a>
                </div>
              </div>
            </div>
          </main>
          {!isMob && <Footer />}
        </div>
      </div>
    );
  } else {
    return <ErrorPage errorMessage={errorMessage} />;
  }
};

export default NoMatch;
